'use strict';

(function () {
  const debounce = (callback, wait = 200) => {
    let timeoutId;

    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => callback(...args), wait);
    };
  };

  if (!customElements.get('latest-blog-highlight')) {
    class LatestBlogHighlight extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.slider = this.querySelector('.latest-blog-highlight__grid-slider');
        this.handleResize = debounce(this.handleResize.bind(this), 200);
      }

      connectedCallback() {
        this.initSwiper();
        window.addEventListener('resize', this.handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        this.destroySwiper();
      }

      initSwiper() {
        this.slider = this.querySelector('.latest-blog-highlight__grid-slider');

        if (!this.slider || window.innerWidth >= 750 || this.swiper || typeof window.Swiper === 'undefined') {
          return;
        }

        this.swiper = new window.Swiper(this.slider, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          speed: 500,
          watchOverflow: true,
        });
      }

      destroySwiper() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      handleResize() {
        if (window.innerWidth < 750) {
          this.initSwiper();
        } else {
          this.destroySwiper();
        }
      }
    }

    customElements.define('latest-blog-highlight', LatestBlogHighlight);
  }
})();
